import { render, staticRenderFns } from "./Mapy.vue?vue&type=template&id=2028b41a&scoped=true&"
import script from "./Mapy.vue?vue&type=script&lang=js&"
export * from "./Mapy.vue?vue&type=script&lang=js&"
import style0 from "./Mapy.vue?vue&type=style&index=0&id=2028b41a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2028b41a",
  null
  
)

export default component.exports